export const SHARE_DATA_TYPES = {
  LINK: 'LINK',
  MAP: 'MAP',
  SYMBOL: 'SYMBOL',
} as const
